import * as mEventsActions from '../actions/mEventsActions';
import EventItem from './EventItem';
import iconSearch from '../img/icon-search.png';
import iconXBlack from '../img/icon-x-black.png';
import ListFilter from './ListFilter';
import Pagination from './Pagination';
import PropTypes from 'prop-types';
import QueryString from 'query-string';
import React from 'react';
import SearchClearOrBusy, {SEARCH_BUSY_MIN_MS} from './SearchClearOrBusy';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';
import {
  getDefaultEventDateRange,
  getDefaultEventFilterState,
  getFilteredEvents,
} from '../utils/eventListFilters';


const EVENTS_PER_PAGE = 10;


class MEvents extends React.Component{
  state = {
    currentPage: 1,
    value: '',
    inputValue: '',
    selectedProgram: [],
    selectedCategory: [],
    ...getDefaultEventDateRange(),
    modalOpen: false,
    filtersInitialized: false,
    searchBusy: false,
  };


  constructor(props){
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClearInput = this.handleClearInput.bind(this);
  }
  componentDidMount(){
    //console.log(`MEvents.componentDidMount()`, this.props);

    const query = QueryString.parse(this.props.location.search);
    const programFromUrl = query?.program || null;

    this.props.actions.initMEvents()
      .then(mEvents => {
        if(mEvents){
          this.initializeFilters(mEvents, programFromUrl);
        }
      });
  }
  componentWillUnmount(){
    window.clearTimeout(this._searchBusyTimer);
  }
  initializeFilters(mEvents, programFromUrl = null){
    if(this.state.filtersInitialized) return;

    this.setState({
      ...getDefaultEventFilterState({
        categories: mEvents.categories || [],
        programs: mEvents.programs || [],
        programFromUrl,
      }),
      filtersInitialized: true,
    });
  }
  getAllCategoryIds = () => (this.props.mEvents.categories || []).map(item => item.id);
  getAllProgramIds = () => (this.props.mEvents.programs || []).map(item => item.id);
  getFilteredEventList = () => {
    const {
      value,
      selectedCategory,
      selectedProgram,
      startDate,
      endDate,
    } = this.state;
    const {mEvents} = this.props;

    return getFilteredEvents(
      mEvents.events,
      value,
      selectedCategory,
      selectedProgram,
      startDate,
      endDate,
      this.getAllCategoryIds(),
      this.getAllProgramIds(),
    );
  };


  handleCategoryFilter = (value, type) => {
    if(type === 'category'){
      const {selectedCategory} = this.state;
      const next = selectedCategory.includes(value)
        ? selectedCategory.filter(id => id !== value)
        : [...selectedCategory, value];
      this.setState({selectedCategory: next});
    }
    else if(type === 'program'){
      const {selectedProgram} = this.state;
      const next = selectedProgram.includes(value)
        ? selectedProgram.filter(id => id !== value)
        : [...selectedProgram, value];
      this.setState({selectedProgram: next});
    }
  };
  handleClearFilter = () => {
    const {mEvents} = this.props;
    this.setState({
      ...getDefaultEventFilterState({
        categories: mEvents.categories || [],
        programs: mEvents.programs || [],
      }),
      currentPage: 1,
    });
  };
  handleClearInput = () => {
    window.clearTimeout(this._searchBusyTimer);
    this.setState({
      value: '',
      inputValue: '',
      currentPage: 1,
      searchBusy: false,
    });
  };
  handleEndDate = endDate => {
    this.setState({
      endDate,
    });
  };
  handleInputChange = evt => {
    this.setState({
      inputValue: evt.target.value,
    });
  };
  handleSearchSubmit = evt => {
    evt.preventDefault();
    this.setState({
      value: this.state.inputValue,
      currentPage: 1,
      searchBusy: true,
    });
    window.clearTimeout(this._searchBusyTimer);
    this._searchBusyTimer = window.setTimeout(() => {
      this.setState({searchBusy: false});
    }, SEARCH_BUSY_MIN_MS);
  };
  handleModalShow = () => {
    this.setState({
      modalOpen: true,
    });
  };
  handleModalHide = () => {
    this.setState({
      modalOpen: false,
    });
  };
  handlePagination = page => {
    this.setState({
      currentPage: page,
    });
  };
  handleStartDate = startDate => {
    this.setState({
      startDate,
    });
  };


  renderEvents = () => {
    const {currentPage} = this.state;
    const {mEvents} = this.props;

    if(!mEvents.events) return null;
    const newEvents = this.getFilteredEventList();

    return newEvents
      .slice((currentPage - 1) * EVENTS_PER_PAGE, EVENTS_PER_PAGE * currentPage)
      .map((event, index) => {
        return (
          <div key={event.id} className="col-12">
            <EventItem event={event}
                       className={index === EVENTS_PER_PAGE - 1 ? 'remove--border' : ''}/>
          </div>
        );
      });
  };
  renderResultStatus = () => {
    const {mEvents} = this.props;
    const {currentPage} = this.state;

    if(!mEvents.events) return null;
    const newEvents = this.getFilteredEventList();
    const startFrom = (currentPage - 1) * EVENTS_PER_PAGE + 1;
    const lastTo =
      currentPage * EVENTS_PER_PAGE > newEvents.length
      ? newEvents.length
      : currentPage * EVENTS_PER_PAGE;

    if(newEvents.length === 0) return null;

    return (
      <div className="m-events__results">
        {`Showing ${startFrom}-${lastTo} of ${newEvents.length}`}
      </div>
    );
  };
  renderFilterButton = () => (
    <button type="button"
            className="m-events__filter-button"
            aria-label="Filter Events"
            onClick={this.handleModalShow}>
      Filter
    </button>
  );
  render(){
    //console.log(`MEvents render`, this.props);
    if(!this.props.mEvents ||
       !this.props.mEvents.events) return null;

    const {
      inputValue,
      selectedCategory,
      selectedProgram,
      startDate,
      endDate,
      modalOpen,
      searchBusy,
    } = this.state;
    const {mEvents} = this.props;
    const filteredEvents = this.getFilteredEventList();
    const totalPage = mEvents && mEvents.events && mEvents.events.length > 0
      ? Math.ceil(filteredEvents.length / EVENTS_PER_PAGE)
      : 0;

    const isOpen = Boolean(inputValue);

    return (
      <div className="columns">
        <div className="coupling coupling--parent coupling--left">
          <div className={`m-events ${this.props.className || ''}`}>
            <div className="container container--coupling">
              <div className="m-events__search-row">
                <form className={`button-input ${isOpen ? 'search-input-open' : ''}`}
                      role="search"
                      onSubmit={this.handleSearchSubmit}>
                  <button aria-label="Search"
                          className="button-input__button"
                          type="submit">
                    <img alt="" className="button-input__button-icon" src={iconSearch}/>
                  </button>

                  <input aria-label="Search Input"
                         className={`button-input__input input ${isOpen ? 'search-input-open' : ''}`}
                         type="text"
                         name="query"
                         value={inputValue}
                         placeholder="Search events and meetings by phrase or keyword"
                         aria-busy={searchBusy ? true : undefined}
                         onChange={this.handleInputChange}/>

                  {(isOpen || searchBusy) && <SearchClearOrBusy isLoading={searchBusy}
                                                               iconSrc={iconXBlack}
                                                               onClear={this.handleClearInput}/>}
                </form>
                {this.renderFilterButton()}
              </div>
              {this.renderResultStatus()}
              {totalPage === 0 && (
                <div className="no-search-results">
                  <div>
                    {`Sorry this search doesn't have any results.`}
                  </div>
                  <div className="no-results-suggestion">
                    Search Suggestions
                    <ul>
                      <li>Check spelling</li>
                      <li>Try more general words</li>
                      <li>Remove some search filters</li>
                      <li>
                        <a href="/get-involved" target="_blank">Contact us</a> {`if you still can't find what you are looking for`}
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              <div className="m-events__listing">
                <div className="row">{this.renderEvents()}</div>
              </div>
              <Pagination
                totalPage={totalPage}
                currentPage={this.state.currentPage}
                handlePagination={this.handlePagination}
              />
            </div>
          </div>
        </div>
        <div className="coupling coupling--parent coupling--right">
          <ListFilter programs={mEvents.programs || []}
                      selectedProgram={selectedProgram}
                      categories={mEvents.categories || []}
                      selectedCategory={selectedCategory}
                      title="Filter Events"
                      startDate={startDate}
                      endDate={endDate}
                      handleCategoryFilter={this.handleCategoryFilter}
                      handleStartDate={this.handleStartDate}
                      handleEndDate={this.handleEndDate}
                      handleClearFilter={this.handleClearFilter}
                      modalOpen={modalOpen}
                      handleModalHide={this.handleModalHide}/>
        </div>
      </div>
    );
  }
}


export default withRouter(connect(
  (state) => ({
    mEvents: state.mEvents,
  }),
  dispatch => ({
    actions: bindActionCreators(mEventsActions, dispatch),
  }),
)(MEvents));


MEvents.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  location: PropTypes.object,
  mEvents: PropTypes.object,
};
